import { render, staticRenderFns } from "./recipesPdf.vue?vue&type=template&id=cefe0b4e&scoped=true&"
import script from "./recipesPdf.vue?vue&type=script&lang=js&"
export * from "./recipesPdf.vue?vue&type=script&lang=js&"
import style0 from "./recipesPdf.vue?vue&type=style&index=0&id=cefe0b4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cefe0b4e",
  null
  
)

export default component.exports